interface ReusableSelectProps<T> {
  options: T[];
  getOptionLabel: (option: T) => string;
  getOptionValue: (option: T) => string | number;
  onChange: (selectedValue: T) => void;
  placeholder?: string;
  className?: string;
  value?: string | number;
  isDisabled?: boolean;
}

function ReusableSelect<T>({
  options,
  getOptionLabel,
  getOptionValue,
  onChange,
  placeholder,
  className,
  value,
  isDisabled = false,
}: ReusableSelectProps<T>) {
  return (
    <select
      className={className}
      value={value !== null && value !== undefined ? String(value) : ''}
      disabled={isDisabled}
      onChange={(e) => {
        const selectedValue = e.target.value;
        const foundOption = options.find(
          (option) => String(getOptionValue(option)) === selectedValue,
        );
        if (foundOption) {
          onChange(foundOption); // Trigger parent's onChange callback
        }
      }}
    >
      <option className="text-text-textColorWhiteBlack" value="" disabled>
        {placeholder}
      </option>
      {options.map((option, index) => (
        <option
          key={index}
          value={String(getOptionValue(option))}
          className="text-text-primary"
        >
          {getOptionLabel(option)}
        </option>
      ))}
    </select>
  );
}

export default ReusableSelect;
